import React, { useContext } from 'react';
import ModalModule from '../modal';
import Utils from '../utils';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { Session, Util } = Utils;

const PlanChangedSuccessfulModal = ({ modalId, data }) => {
	const { newPlanPrice, isUpgrade, onUpgradePlanCallback, newPlanId } = data;
	const { brandName, contactPhoneNumber } = Session.getBrand();
	const { BillingDayOfMonth, CurrentServiceFees } = Session.getInternalAccountInfo();
	const { closeModal } = useContext(ModalContext);

	const onPrimaryButtonClick = () => {
		if (onUpgradePlanCallback) {
			onUpgradePlanCallback(newPlanId);
		}
		closeModal(modalId, ModalButtonActionType.Ok);
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'OK',
		onClick: onPrimaryButtonClick,
		dataqa: 'plan-changed-successful-ok-button',
	};

	const renderFooter = () => (
		<div className="footer">
			<span className="message-icon" />
			<p className="footer-text">
				<a
					href={
						brandName === 'Stamps.com'
							? 'https://help.stamps.com/hc/en-us/articles/20821937508379'
							: 'https://help.endicia.com/hc/en-us/articles/20822851776027'
					}
					target="_blank"
					rel="noopener noreferrer"
				>
					Learn more about your subscriptions, plans, and billing cycles
				</a>{' '}
				, or contact support with your questions at {contactPhoneNumber}, Monday-Friday 6 am
				- 6 pm Pacific Time.
			</p>
		</div>
	);

	const planChangeText = () => {
		const billingDate = Util.getBillingDate(BillingDayOfMonth);
		const nextDayBillingDate = Util.getNextDay(billingDate);

		if (isUpgrade) {
			return (
				<div className="plan-change-info">
					<p className="section1">
						You can start using your new plan features in just a few minutes.
					</p>
					<p className="section2">
						Here are a few things to keep in mind about your billing cycles:
					</p>
					<div className="list">
						<ul>
							<li>
								{brandName} bills at the end of the billing cycle for the prior
								month of service
							</li>
							<li>
								Your next bill will reflect your prior plan cost ($
								{CurrentServiceFees}) + a prorated amount for your new plan
								selection
							</li>
							<li>
								The following bills will reflect your new plan cost (${newPlanPrice}
								) + applicable taxes, if any
							</li>
						</ul>
					</div>
					{renderFooter()}
				</div>
			);
		} else {
			return (
				<div className="plan-change-info">
					<p className="section1">
						Your new plan will go into effect on the first day of your next billing
						cycle {nextDayBillingDate}.
					</p>
					<p className="section2">
						Here are a few things to keep in mind about your billing cycles:
					</p>
					<div className="list">
						<ul>
							<li>
								{brandName} bills at the end of the billing cycle for the prior
								month of service
							</li>
							<li>
								Your next bill will reflect your current plan cost ($
								{CurrentServiceFees}) minus a prorated amount from your new plan
								selection.
							</li>
							<li>
								The following bills will reflect your new plan cost (${newPlanPrice}
								) + applicable taxes, if any.
							</li>
						</ul>
					</div>
					{renderFooter()}
				</div>
			);
		}
	};

	return (
		<Modal
			modalId={modalId}
			className="subscription-plan plan-changed-succesful-modal"
			header="Plan Change Successful!"
			primaryButton={primaryButton}
		>
			<div className="body">{planChangeText()}</div>
		</Modal>
	);
};

export default PlanChangedSuccessfulModal;
